import React from 'react';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './DigitalBankTermsModal.css';
import { IDigitalBankTermsRow } from '../../types/shared/DigitalBankTerms';
import { Button } from '../../importCL';

interface DigitalBankTermsModalProps {
    termsData?: DigitalBankTermsData;
    closeCallback?: () => void;
}

export interface DigitalBankTermsData {
    title?: string;
    subtitle?: string;
    columnOneLabel?: string;
    columnTwoLabel?: string;
    columnThreeLabel?: string;
    tableRows?: IDigitalBankTermsRow[];
}

const DigitalBankTermsModal = (props: DigitalBankTermsModalProps) => {

    return (
        <div className='digitalBankTermsModal'>
            <p className='digitalBankTermsModal__title'>
                {transformHTMLParserLinks(props.termsData?.title || '')}
            </p>
            <p className='digitalBankTermsModal__subtitle'>
                {transformHTMLParserLinks(props.termsData?.subtitle || '')}
            </p>
            <table className='digitalBankTermsModal__table'>
                <thead>
                    <tr className='digitalBankTermsModal__tableHeaderRow'>
                        <th>{transformHTMLParserLinks(props.termsData?.columnOneLabel || '')}</th>
                        <th>{transformHTMLParserLinks(props.termsData?.columnTwoLabel || '')}</th>
                        <th>{transformHTMLParserLinks(props.termsData?.columnThreeLabel || '')}</th>
                    </tr>
                    <tr className='digitalBankTermsModal__tableHeaderRow'>
                        <td colSpan={3}>
                            <hr/>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    {props.termsData?.tableRows?.length && props.termsData?.tableRows.map((row, idx, arr) => {
                        return (
                            <React.Fragment key={idx}>
                                <tr className='digitalBankTermsModal__tableRow'>
                                    <td>{transformHTMLParserLinks(row?.columnOne || '')}</td>
                                    <td>{transformHTMLParserLinks(row?.columnTwo || '')}</td>
                                    <td>
                                        {/*Links are only allowed to be internal as per requirements*/}
                                        <a href={row?.columnThreeLink || ''}>
                                            {row?.columnThreeText || ''}
                                        </a>
                                    </td>
                                </tr>
                                {idx !== arr.length - 1 && (
                                    <tr className='digitalBankTermsModal__tableRow'>
                                        <td colSpan={3}>
                                            <hr/>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
            <Button onClick={props.closeCallback}
                size='medium'
                target='_self'
                variant='solid'>Close</Button>
        </div>
    );
};

export default DigitalBankTermsModal;